/* ============================================================
   TEMA — comportamento

   Regra que vale para o arquivo inteiro: nada aqui pode ser
   necessário para comprar. O formulário do produto e os links da
   sacola são nativos e funcionam sozinhos; o que está abaixo apenas
   evita recarregar a página. Se este arquivo não carregar, a loja
   continua vendendo.
============================================================ */
(function () {
  'use strict';

  var $ = function (sel, raiz) { return (raiz || document).querySelector(sel); };
  var $$ = function (sel, raiz) {
    return Array.prototype.slice.call((raiz || document).querySelectorAll(sel));
  };

  /* Raiz das rotas da loja — "/" na maioria, "/pt-br" quando a loja
     tem mais de um idioma. Quem define é a Shopify, dentro do
     content_for_header.

     A alternativa seria ler o objeto direto em cada chamada. Não dá:
     em qualquer página onde ele não exista (uma prévia fora da
     Shopify, um app que engula o header), o erro estoura na primeira
     linha e leva junto o menu e a sacola — coisas que não têm nada a
     ver com rota. */
  var RAIZ = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ============================================================
     MENU DO CELULAR
  ============================================================ */
  (function menu() {
    var botao = $('#nav-toggle');
    var links = $('#nav-links');
    if (!botao || !links) return;

    botao.addEventListener('click', function () {
      var aberto = links.classList.toggle('is-open');
      botao.setAttribute('aria-expanded', aberto ? 'true' : 'false');
    });
  })();

  /* ============================================================
     SOMBRA DA BARRA AO ROLAR
  ============================================================ */
  (function sombra() {
    var barra = $('#navbar');
    if (!barra) return;
    var alvo = document.createElement('div');
    alvo.style.cssText = 'position:absolute;top:0;height:1px;width:1px';
    document.body.prepend(alvo);

    if (!('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (e) {
      barra.classList.toggle('scrolled', !e[0].isIntersecting);
    }).observe(alvo);
  })();

  /* ============================================================
     SACOLA LATERAL
  ============================================================ */
  var Sacola = (function () {
    var drawer = $('#cart-drawer');
    if (!drawer) return { abrir: function () {}, recarregar: function () {} };

    var corpo = $('#cart-body');
    var rodape = $('#cart-foot');
    var totalEl = $('#cart-total');
    var contador = $('#cart-count');

    function abrir() { drawer.classList.add('is-open'); }
    function fechar() { drawer.classList.remove('is-open'); }

    var b;
    if ((b = $('#btn-open-cart'))) b.addEventListener('click', abrir);
    if ((b = $('#cart-close'))) b.addEventListener('click', fechar);
    if ((b = $('#cart-backdrop'))) b.addEventListener('click', fechar);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) fechar();
    });

    function dinheiro(centavos) {
      /* A Shopify guarda valor em centavos. Sem trocar o ponto pela
         vírgula, um pedido de R$ 289 apareceria como "R$ 289.00". */
      var v = (Number(centavos) || 0) / 100;
      var inteiro = v % 1 === 0;
      return 'R$ ' + v.toFixed(inteiro ? 0 : 2).replace('.', ',');
    }

    function pintarContador(n) {
      if (!contador) return;
      contador.textContent = n;
      contador.dataset.count = String(n);
    }

    /* Redesenha a sacola a partir do servidor. Nunca a partir do que
       está na tela: quantidade que o servidor cortou (estoque) tem de
       aparecer aqui, e não continuar mostrando o que se pediu. */
    function recarregar() {
      return fetch(RAIZ + 'cart.js', {
        headers: { 'Accept': 'application/json' }
      })
        .then(function (r) { return r.json(); })
        .then(function (carrinho) {
          pintarContador(carrinho.item_count);
          if (totalEl) totalEl.textContent = dinheiro(carrinho.total_price);
          if (rodape) rodape.hidden = carrinho.item_count === 0;
          if (corpo) desenharItens(carrinho);
          return carrinho;
        })
        .catch(function () { /* deixa a tela como está */ });
    }

    function esc(s) {
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function desenharItens(carrinho) {
      if (!carrinho.items.length) {
        corpo.innerHTML =
          '<div class="cart-empty"><strong>Sua sacola está vazia</strong>' +
          '<span>Escolha uma peça e o tamanho para começar.</span></div>';
        return;
      }
      var raiz = RAIZ;
      corpo.innerHTML = carrinho.items.map(function (it, i) {
        var linha = i + 1;
        var variante = (it.variant_title && it.variant_title !== 'Default Title')
          ? '<div class="cart-item-meta">' + esc(it.variant_title) + '</div>' : '';
        return '<div class="cart-item" data-linha="' + linha + '">' +
          '<div class="cart-item-name">' + esc(it.product_title) + '</div>' +
          '<div class="cart-item-price">' + dinheiro(it.final_line_price) + '</div>' +
          variante +
          '<div class="cart-item-qty">' +
            '<a class="qty-btn" data-act="dec" href="' + raiz + 'cart/change?line=' + linha +
              '&quantity=' + (it.quantity - 1) + '" aria-label="Diminuir">−</a>' +
            '<span class="qty-val">' + it.quantity + '</span>' +
            '<a class="qty-btn" data-act="inc" href="' + raiz + 'cart/change?line=' + linha +
              '&quantity=' + (it.quantity + 1) + '" aria-label="Aumentar">+</a>' +
            '<a class="cart-item-remove" data-act="remove" href="' + raiz + 'cart/change?line=' + linha +
              '&quantity=0">Remover</a>' +
          '</div>' +
        '</div>';
      }).join('');
    }

    /* Os botões de quantidade são links de verdade. Interceptamos o
       clique para fazer por fetch; sem JavaScript, o link navega e o
       resultado é o mesmo, só com recarga. */
    document.addEventListener('click', function (e) {
      var alvo = e.target.closest('#cart-drawer [data-act]');
      if (!alvo) return;
      e.preventDefault();

      var url = new URL(alvo.href, location.origin);
      fetch(RAIZ + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          line: Number(url.searchParams.get('line')),
          quantity: Number(url.searchParams.get('quantity'))
        })
      }).then(recarregar);
    });

    return { abrir: abrir, fechar: fechar, recarregar: recarregar };
  })();

  /* ============================================================
     PÁGINA DO PRODUTO
  ============================================================ */
  (function produto() {
    var form = $('#form-produto');
    if (!form) return;

    var select = $('#variante');
    var quantidade = $('#quantity');
    var qtdValor = $('#qtd-valor');
    var precoEl = $('#preco-total');
    var compararEl = $('#preco-comparar');
    var botao = $('#btn-selecionar');
    var msg = $('#compra-msg');

    /* ---------- galeria ---------- */
    var principal = $('#foto-principal') || $('#galeria-principal img');
    var thumbs = $('#galeria-thumbs');
    if (thumbs && principal) {
      thumbs.addEventListener('click', function (e) {
        var b = e.target.closest('.galeria-thumb');
        if (!b) return;
        principal.src = b.dataset.foto;
        principal.removeAttribute('srcset');
        $$('.galeria-thumb', thumbs).forEach(function (t) { t.classList.remove('is-active'); });
        b.classList.add('is-active');
      });
    }

    /* ---------- quantidade ---------- */
    function pintarQtd() {
      var n = Number(quantidade.value) || 1;
      if (qtdValor) qtdValor.textContent = n + (n === 1 ? ' unidade' : ' unidades');
      var menos = $('#qtd-menos');
      if (menos) menos.disabled = n <= 1;
    }
    var el;
    if ((el = $('#qtd-menos'))) el.addEventListener('click', function () {
      quantidade.value = Math.max(1, (Number(quantidade.value) || 1) - 1);
      pintarQtd();
    });
    if ((el = $('#qtd-mais'))) el.addEventListener('click', function () {
      quantidade.value = (Number(quantidade.value) || 1) + 1;
      pintarQtd();
    });
    pintarQtd();

    /* ---------- variantes ----------
       Os botões redondos só empurram o valor para o <select>, que é
       quem o formulário envia de verdade. */
    if (select) {
      $$('.tamanho-opcoes').forEach(function (grupo) {
        grupo.addEventListener('click', function (e) {
          var b = e.target.closest('.tamanho-btn');
          if (!b || b.disabled) return;

          $$('.tamanho-btn', grupo).forEach(function (o) { o.classList.remove('is-active'); });
          b.classList.add('is-active');

          var escolhidos = $$('.tamanho-opcoes').map(function (g) {
            var ativo = g.querySelector('.tamanho-btn.is-active');
            return ativo ? ativo.dataset.valor : null;
          });

          var alvo = Array.prototype.find.call(select.options, function (op) {
            var partes = op.textContent.trim().split(' / ');
            return escolhidos.every(function (v, i) {
              return v === null || partes[i] === v;
            });
          });

          if (alvo) {
            select.value = alvo.value;
            precoEl.textContent = alvo.dataset.preco;
            if (compararEl) {
              compararEl.textContent = alvo.dataset.comparar || '';
              compararEl.hidden = !alvo.dataset.comparar;
            }
            var disponivel = alvo.dataset.disponivel === 'true';
            botao.disabled = !disponivel;
            botao.textContent = disponivel ? 'Adicionar à sacola' : 'Esgotado';
          }
          if (msg) msg.textContent = '';
        });
      });
    }

    /* ---------- adicionar à sacola ----------
       Por fetch, para a pessoa não perder a página do produto. Se
       der qualquer erro, deixamos o formulário seguir do jeito
       nativo em vez de travar a compra. */
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();

      botao.disabled = true;
      if (msg) { msg.textContent = 'Adicionando…'; msg.classList.remove('is-erro'); }

      fetch(RAIZ + 'cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) {
          return r.json().then(function (d) {
            if (!r.ok) throw new Error(d.description || d.message || 'Não foi possível adicionar.');
            return d;
          });
        })
        .then(function () {
          if (msg) msg.textContent = 'Adicionado à sacola.';
          return Sacola.recarregar().then(Sacola.abrir);
        })
        .catch(function (erro) {
          if (msg) { msg.textContent = erro.message; msg.classList.add('is-erro'); }
        })
        .finally(function () { botao.disabled = false; });
    });
  })();

  /* ============================================================
     ENTRADA DOS BLOCOS AO ROLAR
     Só decoração: sem IntersectionObserver, tudo já está visível.
  ============================================================ */
  (function reveal() {
    var alvos = $$('.reveal');
    if (!alvos.length) return;

    var semMovimento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (semMovimento || !('IntersectionObserver' in window)) {
      alvos.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var obs = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('is-visible');
          obs.unobserve(en.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });

    alvos.forEach(function (el) { obs.observe(el); });
  })();
})();
